import React from "react";

import styled from "@emotion/styled";

import { roundNumber } from "../../../../../utils/NumberHelpers";
import { iShopwareProduct } from "../../store";

const Wrapper = styled.div`
    margin: 10px 0;
`;

export const SmallText = styled.div`
    font-size: small;
`;

interface iProps {
    product: iShopwareProduct;
}
const RegulationPrice = ({ product }: iProps) => {
    const getNetPrice = () => {
        return (
            product.calculatedCheapestPrice.calculatedTaxes[0].price /
            (1 +
                product.calculatedCheapestPrice.calculatedTaxes[0].taxRate /
                    100)
        );
    };
    return (
        <Wrapper>
            {product.calculatedCheapestPrice?.regulationPrice?.price && (
                <SmallText>
                    Günstigster Preis der letzten 30 Tage:{" "}
                    {roundNumber(
                        product.calculatedCheapestPrice.regulationPrice.price
                    )}{" "}
                    €
                </SmallText>
            )}
            <SmallText>Nettopreis: {roundNumber(getNetPrice())} €</SmallText>
        </Wrapper>
    );
};

export default RegulationPrice;
